import { Component, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { AlertaService } from '../alerta/alerta.service';
import { LoadingService } from '../loading/loading.service';
import { UsuarioService } from '../usuario/usuario.service';
import { ReportesService } from './reportes.service';
import { provideNativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { iReportes } from './reportes.interface';
import moment from 'moment';

@Component({
  selector: 'app-reportes',
  standalone: true,
  imports: [MatCardModule, MatChipsModule, MatProgressBarModule, MatButtonModule, MatDividerModule, MatIconModule, 
    ReactiveFormsModule, MatToolbarModule, MatInputModule, MatFormFieldModule, FormsModule, 
    MatSelectModule, MatDatepickerModule, CommonModule, MatListModule],
  providers: [provideNativeDateAdapter(), {provide: MAT_DATE_LOCALE, useValue: 'es-MX'}],
  templateUrl: './reportes.component.html',
  styleUrl: './reportes.component.css'
})
export class ReportesComponent {
  private loadingService = inject(LoadingService);
  private reportesService = inject(ReportesService);
  private usuarioService = inject(UsuarioService);
  private alertaService = inject(AlertaService);
  private formBuilder:FormBuilder = inject(FormBuilder);
  
  public formReportes!: FormGroup;
  public moment: any = moment;
  public catTipo = [
    {id:1, descripcion:"Correos enviados a BBDG"},
    {id:2, descripcion:"Correos enviados por diversos medios"},
    {id:3, descripcion:"Correos sin Respuesta a Presidencia"}, 
    {id:4, descripcion:"Asignado a"},
    {id:5, descripcion:"Sobre Cerrado"}
  ];

  public rows: any = {};
  public titulos: any = [];
  public sinResultados:boolean = false;
  public tipoReporte: string = '';
  public campos: any = {};
  public showReport: boolean = false;
  public dataSource: iReportes [] = [];

  constructor() {
    this.loadingService.show();

    this.formReportes = this.formBuilder.group({
      tipo: ['', [Validators.required]],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]]
    });

    this.loadingService.hide();
  }

  async ngOnInit() {
    this.formReportes.get('tipo')?.valueChanges.subscribe(value => {
      if(value == 3) {
        //this.formReportes.controls['fechaInicio'].setValue('');
        //this.formReportes.controls['fechaFin'].setValue('');
        this.formReportes.controls['fechaInicio'].clearValidators();
        this.formReportes.controls['fechaFin'].clearValidators();
      } else {
        this.formReportes.controls['fechaInicio'].setValidators([Validators.required]);
        this.formReportes.controls['fechaFin'].setValidators([Validators.required]);
      }

      this.formReportes.controls['fechaInicio'].updateValueAndValidity();
      this.formReportes.controls['fechaFin'].updateValueAndValidity();
    });
  }

  getHeaders (tipo: number) {
    if(tipo == 1) return ["Fecha de envío a BB","Enviado por","Empresa","Tipo","Asunto"];
    if(tipo == 2) return ["Fecha de envío","Enviado por","Empresa","Tipo","Asunto", "Medio"];
    if(tipo == 3) return ["Número","Empresa","Enviado a","Asunto","Fecha inicio","Fecha fin","Estatus"];
    if(tipo == 4) return ["Número","Usuario supervisor","Usuario analista","Asunto","Tipo de entregable","Fecha y hora de creación del entregable","Estatus","Fecha y hora de terminación del entregable"];
    if(tipo == 5) return ["ID sobre", "Asunto", "Fecha inicio de entrada", "Remitente"];
    return [];
  }

  setDescripcion () {
    const tipo = this.formReportes.get('tipo')?.value;
    this.titulos = this.getHeaders(tipo);
    this.tipoReporte = this.catTipo[tipo - 1].descripcion;
  }

  inicializaValores () {
    this.rows = { "1": [], "2": [], "3": [], "4": [], "5": [] };
    this.sinResultados = false;
    this.showReport = false;
  }

  consultaReporte() {
    this.loadingService.show();
    this.inicializaValores();
    this.setDescripcion();
    let data = this.formReportes.value;

    this.reportesService.obtenerConsulta({
      fechaInicio: data.tipo !== 3 ? moment(data.fechaInicio).format('YYYY-MM-DD') : '',
      fechaFin: data.tipo !== 3 ? moment(data.fechaFin).format('YYYY-MM-DD') : '',
      tipo: data.tipo
    }).subscribe({
      next: (result: any) => {
        if(data.tipo == 3) {
          result.rows = result.rows.map((item: iReportes) => {
            item.idEstatus = this.calculaStatus(item.fechaInicio_string!, item.fechaFin_string!);
            item.remitente_enviado_descripcion = this.formatPersona(item.remitente_enviado_descripcion!);
            return item;
          });
        }
        
        this.rows[data.tipo] = result.rows;
        this.sinResultados = (result.rows.length == 0)?true:false;
        this.showReport = true;
        this.loadingService.hide();
      },
      error: (error) => {
        console.log(error);
        this.alertaService.open('Error', 'Ups tenemos problemas al obtener los datos');
      },
      complete: () => {
        console.log('complete');
        this.loadingService.hide();
      },
    });
  }
  
  calculaStatus(fecha_ini: string, fecha_fin: string){
    var hoy = moment();
    var ini = moment(fecha_ini + "T00:00:00.00");
    var fin = moment(fecha_fin + "T23:00:00.00");
    
    var dif = fin.diff(ini, 'days');
    var dif2 = fin.diff(hoy, 'days');
    var porcentaje = dif2 * 100 / dif;
    
    if (porcentaje > 25) {
      return 1; //A TIEMPO
    } else if (porcentaje > 0) {
      return 2; // POR VENCER
    } else { 
      return 3; // VENCIDO
    }
  }

  formatPersona(strCadena: string) {
    return strCadena.split(" | ").filter((item: any) => !item.includes("@") && item != "").join(", ");
  }

  descargaReporte() {
    this.loadingService.show();
    const data = this.formReportes.value;
    this.setDescripcion();

    this.reportesService.obtenerDescarga({
      fechaInicio: data.tipo !== 3 ? moment(data.fechaInicio).format('YYYY-MM-DD') : '',
      fechaFin: data.tipo !== 3 ? moment(data.fechaFin).format('YYYY-MM-DD') : '',
      tipo: data.tipo
    }).subscribe({
      next: (dataFile: any) => {
        if (!dataFile.error) {
          this.download(dataFile);
        } else {
          this.alertaService.open("Error 040", dataFile.message);
        }
      },
      error: (error) => {
        this.alertaService.open('Error', 'Ups tenemos problemas al generar el archivo');
      },
      complete: () => {
        this.loadingService.hide();
      },
    });
  } 

  verEntrada (item: any) {
    let tema = (item.tema)? item.tema: item.idTema;
    let entrada =  (item.entrada)? item.entrada: item.idEntrada;
    window.open(`/entrada/${tema}/${entrada}`, '_blank');
  }

  download(data: BlobPart) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    let fileName = `${this.tipoReporte} - ${moment().format('YYYY/MM/DD HH:mm:ss')}.xlsx`;
    var link = document.createElement("a");

    link.id = this.tipoReporte;
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    this.loadingService.hide();
    // Revocar el objeto URL y eliminar el elemento por clase
    setTimeout(() => {
      window.URL.revokeObjectURL(link.href);
      const elements = document.getElementById(this.tipoReporte);
      elements?.remove();
    }, 2000);
  }

}